import { useDispatch, useSelector } from 'react-redux';

import {
    analyticsPerpayCreditCardOnboardingUnfreezeMVP2ClickDone,
    analyticsPerpayCreditCardOnboardingUnfreezeMVP2ClickTryAgain,
} from '@perpay-web/fintech/actions/analytics/cardOnboardingMVP2';
import CardApplicationUnfreeze from '@perpay-web/fintech/components/composite/CardApplicationUnfreeze/CardApplicationUnfreeze';
import {
    creditUnfreezeForCardAccountApplicationDataModule,
    getIsLoading,
    getIsClarityFrozen,
} from '@perpay-web/fintech/dataModules/creditUnfreezeCardAccountApplication';
import { getCardAccountApplicationUuid } from '@perpay-web/fintech/dataModules/crud/cardAccountApplication';

const CardApplicationUnfreezeContainer = ({ isPHO = false }) => {
    const dispatch = useDispatch();
    const cardAccountApplicationUuid = useSelector(
        getCardAccountApplicationUuid,
    );
    const isLoading = useSelector(getIsLoading);
    const isClarityFrozen = useSelector(getIsClarityFrozen);

    const onClickDone = () => {
        dispatch(analyticsPerpayCreditCardOnboardingUnfreezeMVP2ClickDone());
    };

    const onClickTryAgain = () => {
        // Reset any previous error state before making new request
        dispatch(creditUnfreezeForCardAccountApplicationDataModule.dataReset());

        dispatch(
            creditUnfreezeForCardAccountApplicationDataModule.dataRequest(
                cardAccountApplicationUuid,
            ),
        );
        dispatch(
            analyticsPerpayCreditCardOnboardingUnfreezeMVP2ClickTryAgain(),
        );
    };

    return (
        <CardApplicationUnfreeze
            onClickDone={onClickDone}
            onClickTryAgain={onClickTryAgain}
            isPHO={isPHO}
            isLoading={isLoading}
            showRetryMessage={isClarityFrozen}
        />
    );
};

export default CardApplicationUnfreezeContainer;
